import { authFetch } from './api';

// Legacy deployments complete synchronously. The MCP-enabled backend returns
// a durable operation; do not clear the selection before cleanup succeeds.
// Resolves { webflowSites }: Webflow sites the agent's script was taken off,
// to be published so it leaves the live site too.
export async function deleteAgent(agentId) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const response = await authFetch(`${base}bots/${agentId}`, {
    method: 'DELETE', headers: { 'Idempotency-Key': `delete-${crypto.randomUUID()}` },
  });
  if (!response?.ok) throw new Error('DELETE_NOT_COMPLETED');
  if (response.status !== 202) {
    const done = await response.json().catch(() => ({}));
    return { webflowSites: Array.isArray(done.webflow_sites_to_publish) ? done.webflow_sites_to_publish : [] };
  }
  const queued = await response.json();
  if (!queued.operation_id) throw new Error('DELETE_NOT_COMPLETED');
  for (let attempt = 0; attempt < 60; attempt += 1) {
    const check = await authFetch(`${base}mcp-platform/get_operation`, {
      method: 'POST', body: JSON.stringify({ operation_id: queued.operation_id }),
    });
    if (!check?.ok) throw new Error('DELETE_NOT_COMPLETED');
    const operation = await check.json();
    if (operation.status === 'succeeded') return { webflowSites: [] };
    if (operation.status === 'failed') throw new Error('DELETE_NOT_COMPLETED');
    await new Promise(resolve => setTimeout(resolve, 1000));
  }
  throw new Error('DELETE_NOT_COMPLETED');
}
